<template>
	<div>
		<b-form @submit.prevent="saveGroup">
			<b-form-row>
				<b-form-group class="col-6" label="Nombre del Grupo">
					<b-form-input
						type="text"
						size="sm"
						v-model="form.name"
						required
						placeholder="Ej: Canales Premium"
					/>
				</b-form-group>
				<b-form-group class="col-6" label="Estado">
					<b-form-select
						size="sm"
						v-model="form.status"
						:options="statusOptions"
					></b-form-select>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group class="col-12" label="Descripción">
					<b-textarea
						size="sm"
						v-model="form.description"
						placeholder="Describe el propósito de este grupo..."
						rows="3"
					/>
				</b-form-group>
			</b-form-row>
			<hr />
			<div class="text-right">
				<b-button 
					@click="$emit('cancel')" 
					variant="secondary" 
					class="mr-2"
					:disabled="loading"
				>
					Cancelar
				</b-button>
				<b-button 
					variant="primary" 
					type="submit"
					:disabled="loading"
				>
					<b-spinner v-if="loading" small class="mr-2"></b-spinner>
					{{ modelId > 0 ? "Actualizar" : "Guardar" }}
				</b-button>
			</div>
		</b-form>
	</div>
</template>

<script>
import api from "../../../../api.js";

export default {
	props: {
		modelId: {
			type: Number,
			required: false,
			default: -1
		}
	},
	data() {
		return {
			form: {
				name: "",
				description: "",
				status: "active"
			},
			statusOptions: [
				{ value: "active", text: "Activo" },
				{ value: "inactive", text: "Inactivo" }
			],
			loading: false
		};
	},
	methods: {
		async loadGroup() {
			if (this.modelId <= 0) return;
			
			try {
				this.loading = true;
				const response = await api(this).get(`/sales-channel-groups/${this.modelId}`);
				const group = response.data;
				
				this.form = {
					name: group.name || "",
					description: group.description || "",
					status: group.status || "active"
				};
			} catch (error) {
				this.$root.handleRequestError(error);
			} finally {
				this.loading = false;
			}
		},
		async saveGroup() {
			try {
				this.loading = true;
				
				let response;
				if (this.modelId > 0) {
					// Update existing group
					response = await api(this).put(`/sales-channel-groups/${this.modelId}`, this.form);
				} else {
					// Create new group
					response = await api(this).post('/sales-channel-groups', this.form);
				}
				
				this.$root.showAlert(
					this.modelId > 0 ? 'Grupo actualizado correctamente' : 'Grupo creado correctamente',
					{ variant: 'success' }
				);
				
				this.$emit('saved', response);
			} catch (error) {
				this.$root.handleRequestError(error);
			} finally {
				this.loading = false;
			}
		}
	},
	mounted() {
		this.loadGroup();
	},
	watch: {
		modelId() {
			this.loadGroup();
		}
	}
};
</script>

<style></style>